import { render } from "./SimpleCard.vue?vue&type=template&id=62ab0e06"
import script from "./SimpleCard.vue?vue&type=script&lang=js"
export * from "./SimpleCard.vue?vue&type=script&lang=js"

import "./SimpleCard.vue?vue&type=style&index=0&id=62ab0e06&lang=scss"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__